import ContinuingEducationRequest from "./continuing-education"
import { ChipVariant } from "Components/atoms/chip"


export enum CONTINUING_EDUCATION_STATUS {
    PENDING = "Pending",
    APPROVED = "Approved",
    DECLINED = "Declined",
}

// Statuses are DB rows, so anything seeded later falls through to the default.
export const CONTINUING_EDUCATION_STATUS_VARIANT: Record<string, ChipVariant> = {
    [CONTINUING_EDUCATION_STATUS.PENDING]: 'info',
    [CONTINUING_EDUCATION_STATUS.APPROVED]: 'success',
    [CONTINUING_EDUCATION_STATUS.DECLINED]: 'danger',
}

interface ContinuingEducationStatus {
    id: string
    description: string

    requests?: ContinuingEducationRequest[]
}

export default ContinuingEducationStatus
